import React from 'react';
import { motion } from 'framer-motion';
import { HeartPulse, HardHat, Tractor, Zap, Cpu, Shield } from 'lucide-react';
import { SectionHeader } from './SectionHeader';
export function Sectors() {
  const sectors = [{
    icon: HeartPulse,
    name: 'Healthcare & Medical'
  }, {
    icon: HardHat,
    name: 'Infrastructure & Construction'
  }, {
    icon: Tractor,
    name: 'Agriculture & Food Security'
  }, {
    icon: Zap,
    name: 'Energy & Power'
  }, {
    icon: Cpu,
    name: 'Technology & Telecoms'
  }, {
    icon: Shield,
    name: 'Defense & Security'
  }];
  return <section id="sectors" className="py-24 bg-navy-light border-y border-navy-border" data-id="element-154">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-155">
        <div className="grid lg:grid-cols-3 gap-12 items-start" data-id="element-156">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="lg:col-span-1 lg:sticky lg:top-32" data-id="element-157">
            <SectionHeader eyebrow="Industries" title="Sectors We Serve" description="We facilitate procurement across critical sectors essential for national development and institutional growth." data-id="element-158" />
          </motion.div>

          <div className="lg:col-span-2 grid sm:grid-cols-2 gap-4" data-id="element-159">
            {sectors.map((sector, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.1
          }} className="flex items-center gap-4 p-6 bg-navy-card border border-navy-border rounded-sm hover:bg-navy transition-colors" data-id="element-160">
                <sector.icon size={24} className="text-gold shrink-0" data-id="element-161" />
                <span className="text-white font-semibold" data-id="element-162">{sector.name}</span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}